import React, { useState } from 'react';
import { Menu, X, Search, Bell, User, LogOut, Settings, BarChart3, Tool, Users, Shield } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import ConsoleSidebar from './ConsoleSidebar';
import ConsoleHeader from './ConsoleHeader';

const ConsoleLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Determine current section based on path
  const getCurrentSection = () => {
    const path = location.pathname;
    if (path.startsWith('/console/tools')) {
      return 'tools';
    } else if (path.startsWith('/console/analytics')) {
      return 'analytics';
    } else if (path.startsWith('/console/admin')) {
      return 'admin';
    } else if (path.startsWith('/console/settings')) {
      return 'settings';
    } else if (path.startsWith('/console/documentation')) {
      return 'documentation';
    } else {
      return 'dashboard';
    }
  };

  const handleNavigate = (path) => {
    navigate(path);
    setSidebarOpen(false);
  };

  const handleBackToHome = () => {
    navigate('/');
  };

  const handleDocumentationClick = () => {
    navigate('/console/documentation');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 z-40 bg-gray-600 bg-opacity-75 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <ConsoleSidebar 
        isOpen={sidebarOpen} 
        onClose={() => setSidebarOpen(false)}
        currentSection={getCurrentSection()}
        currentPath={location.pathname}
        onNavigate={handleNavigate}
      />

      {/* Main content */}
      <div className="flex-1">
        {/* Header */}
        <ConsoleHeader 
          onMenuClick={() => setSidebarOpen(true)}
          onBackToHome={handleBackToHome}
          onNavigate={handleNavigate}
          onDocumentationClick={handleDocumentationClick}
        />

        {/* Page content */}
        <main className="p-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default ConsoleLayout; 